/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class PreviewPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(previewPopup, url) {
    previewPopup.setAttribute('url', url);
  }
}
